export type EnvType =
  | 'local'
  | 'ddev'
  | 'stg'
  | 'stg-fedm'
  | 'prod'
  | 'prod-fedm';

const envHostNameMapping: Record<string, EnvType> = {
  localhost: 'local',
  'auth.dev.atlassian.com': 'ddev',
  'auth.stg.atlassian.com': 'stg',
  'auth.atlassian.com': 'prod',
  'auth.stg.atlassian-us-gov-mod.com': 'stg-fedm',
  'auth.atlassian-us-gov-mod.com': 'prod-fedm',
};

export function getEnv(): EnvType {
  return envHostNameMapping[window.location.hostname] ?? 'local';
}

export type Perimeter = 'commercial' | 'fedramp-moderate';

const perimeters: Record<EnvType, Perimeter> = {
  local: 'commercial',
  ddev: 'commercial',
  stg: 'commercial',
  'stg-fedm': 'fedramp-moderate',
  prod: 'commercial',
  'prod-fedm': 'fedramp-moderate',
};

export const currentPerimeter = perimeters[getEnv()];

export const isFedRamp = () => 'fedramp-moderate' === currentPerimeter;
